import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import FileUploader from "../../../../Utils/FileUploader";
import {
  fetchTaskStatus,
  getDocTypeApi,
  uploadDocuments,
  updateDocumentDate,
} from "../../../../Services/DocumentUpload/documentUploadApi";
import { toast } from "react-toastify";
import { resetTaskStatus } from "../../../../Services/DocumentUpload/documentSlice/fetchTaskStatusSlice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./UploadDocuments.css";
import { ProgressBar } from "react-bootstrap";

const UploadDocuments = ({
  commmunityId,
  setDocumentData,
  handleRefetchDox,
}) => {
  const userId = localStorage.getItem("user_id");
  const dispatch = useDispatch();
  const [uploadModalShow, setUploadModalShow] = useState(false);
  const [files, setFiles] = useState([]);
  const [privatetypeId, setPrivatetypeId] = useState();
  const [selectedDocType, setSelectedDocType] = useState(privatetypeId);
  const [docTypes, setDocTypes] = useState();
  const [formData, setFormData] = useState({
    community_id: "",
    doc_type: "",
    doc_type_name: "",
    community_documents: [],
  });
  const [taskId, setTaskId] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [documentDates, setDocumentDates] = useState([]);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!taskId) return;

    const intervalId = setInterval(() => {
      dispatch(fetchTaskStatus(taskId)).then((response) => {
        const status = response?.payload?.data?.status;
        if (status === "completed") {
          toast.success(response?.payload?.message);
          clearInterval(intervalId);
          dispatch(resetTaskStatus());
          setRefetch(!refetch);
          setTaskId(null);
          handleRefetchDox();
        }
      });
    }, 3000);

    return () => clearInterval(intervalId);
  }, [dispatch, taskId]);

  useEffect(() => {
    if (docTypes?.length > 0) {
      const privatetypeId =
        docTypes?.find((type) => type.name === "private")?.id || null;

      setPrivatetypeId(privatetypeId);
      setSelectedDocType(privatetypeId);
    }
  }, [docTypes]);

  useEffect(() => {
    dispatch(getDocTypeApi())
      .unwrap()
      .then((res) => {
        setDocTypes(res.data);
      })
      .catch((err) => {
        toast.error("Failed to fetch document types.");
      });
  }, [dispatch]);

  const handleFileRemove = (fileToRemove) => {
    setFiles((prevSelectedFiles) => {
      const updatedFiles = prevSelectedFiles.filter(
        (file) => file.name !== fileToRemove.name
      );

      setFormData((prevState) => ({
        ...prevState,
        community_documents: updatedFiles,
      }));

      return updatedFiles;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (files.length === 0) {
      toast.error("Please select at least one file to upload");
      return;
    }

    if (files.length > 5) {
      toast.error("Maximum 5 files are allowed");
      return;
    }

    // Validate file types
    const invalidFiles = files.filter((file) => {
      const fileType = file.name.toLowerCase().split(".").pop();
      return !["pdf", "doc", "docx"].includes(fileType);
    });

    if (invalidFiles.length > 0) {
      toast.error("Only PDF and DOC/DOCX files are allowed");
      return;
    }

    const finaldata = new FormData();
    finaldata.append("doc_type", privatetypeId);
    if (selectedDocType === "public") {
      finaldata.append("doc_type_name", formData.doc_type_name);
    }
    files.forEach((file) => finaldata.append("community_documents", file));
    finaldata.append("community_id", commmunityId);
    finaldata.append("user_id", userId);

    dispatch(uploadDocuments(finaldata))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          toast.success("Document uploaded successfully!");
          console.log("Document upload response:", res);
          setDocumentData(res.data);
          setUploadedDocuments(res?.data?.documents);

          setFormData({
            community_id: "",
            doc_type: "",
            doc_type_name: "",
            community_documents: null,
          });
          setFiles([]);
          setUploadModalShow(false);
          setSelectedDocType("");
          setShowDateModal(true);
        }
      })
      .catch((err) => {
        toast.error(err.message + " " + err.errors);
      });
  };

  const handleDateSubmit = (formattedDates) => {
    setLoading(true);

    dispatch(
      updateDocumentDate({
        community_id: commmunityId,
        user_id: userId,
        documents: formattedDates,
      })
    )
      .unwrap()
      .then((res) => {
        toast.success("Document dates saved successfully!");
        setTaskId(res.data.task_id);
        setShowDateModal(false);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.message + " " + err.errors);
        setShowDateModal(false);
        setLoading(false);
      });
  };

  return (
    <div>
      <button
        className="orange-filled-btn addcommunitybtn"
        onClick={() => setUploadModalShow(true)}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 459.904 459.904"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
          className="mx-2"
        >
          <g>
            <path d="M123.465 168.28h46.543v138.07c0 14.008 11.358 25.352 25.352 25.352h69.2c13.993 0 25.352-11.343 25.352-25.352V168.28h46.527c7.708 0 14.637-4.641 17.601-11.764 2.933-7.094 1.301-15.295-4.145-20.741L243.413 29.28c-7.437-7.422-19.485-7.422-26.938 0L110.011 135.775a19.023 19.023 0 0 0-4.13 20.741c2.962 7.109 9.876 11.764 17.584 11.764z" />
            <path d="M437.036 220.029c-12.617 0-22.852 10.237-22.852 22.867v95.615c0 28.643-23.317 51.944-51.961 51.944H97.679c-28.644 0-51.945-23.301-51.945-51.944v-95.615c0-12.63-10.251-22.867-22.867-22.867C10.236 220.029 0 230.266 0 242.897v95.615c0 53.859 43.818 97.679 97.679 97.679h264.544c53.861 0 97.681-43.819 97.681-97.679v-95.615c0-12.631-10.237-22.868-22.868-22.868z" />
          </g>
        </svg>
        Upload Documents
      </button>
      <UploadModal
        show={uploadModalShow}
        onHide={() => setUploadModalShow(false)}
        files={files}
        setFiles={setFiles}
        handleFileRemove={(file) => handleFileRemove(file)}
        handleSubmit={handleSubmit}
      />
      <DateSelectionModal
        show={showDateModal}
        onHide={() => setShowDateModal(false)}
        documents={uploadedDocuments}
        documentDates={documentDates}
        setDocumentDates={setDocumentDates}
        onSubmit={handleDateSubmit}
        loading={loading}
      />
    </div>
  );
};

function UploadModal(props) {
  const { loading } = useSelector((state) => state.uploadDocuments);
  const [uploadProgress, setUploadProgress] = useState(0);

  useEffect(() => {
    // Listen for upload progress
    const handleProgress = (event) => {
      setUploadProgress(event.detail.progress);
    };
    window.addEventListener("upload-progress", handleProgress);
    return () => {
      window.removeEventListener("upload-progress", handleProgress);
    };
  }, []);

  // Reset progress when modal closes
  useEffect(() => {
    if (!props.show) {
      setUploadProgress(0);
    }
  }, [props.show]);

  const fileConfig = {
    maxFiles: 10,
    acceptedFiles: ".pdf,.doc,.docx",
    maxSize: 10 * 1024 * 1024,
  };
  const handleBeforeFileAdd = (file) => {
    if (props.files.length >= fileConfig.maxFiles) {
      toast.error(`Maximum ${fileConfig.maxFiles} files are allowed`);
      return false;
    }

    const fileType = file.name.toLowerCase().split(".").pop();
    const allowedTypes = ["pdf", "doc", "docx"];

    if (!allowedTypes.includes(fileType)) {
      toast.error("Only PDF and DOC/DOCX files are allowed");
      return false;
    }

    return true;
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Upload Document
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && uploadProgress > 0 ? (
          <div className="mt-3">
            <ProgressBar
              now={uploadProgress}
              label={`${uploadProgress}%`}
              className="custom-progress"
              animated
            />
            <p className="text-center mt-2">
              Uploading... {uploadProgress}% complete
            </p>
          </div>
        ) : (
          <FileUploader
            handleFileRemove={props.handleFileRemove}
            files={props.files}
            setFiles={props.setFiles}
            maxFiles={fileConfig.maxFiles}
            acceptedFiles={fileConfig.acceptedFiles}
            // maxSize={fileConfig.maxSize}
            onBeforeAdd={handleBeforeFileAdd}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="bttn-close"
          onClick={props.onHide}
          disabled={loading}
        >
          Close
        </button>
        <button
          className="bttn-upload"
          onClick={props.handleSubmit}
          disabled={loading}
        >
          {loading ? "Uploading..." : "Upload"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

function DateSelectionModal({
  show,
  onHide,
  documents,
  documentDates,
  setDocumentDates,
  onSubmit,
  loading,
}) {
  const [dateErrors, setDateErrors] = useState({});

  // Calculate min and max dates
  const minDate = new Date(1900, 0, 1);
  const maxDate = new Date();

  const formatDateInput = (value) => {
    let numbers = value?.replace(/\D/g, "")?.substring(0, 8);

    const month = numbers?.substring(0, 2);
    const day = numbers?.substring(2, 4);
    const year = numbers?.substring(4);

    if (numbers?.length >= 2 && parseInt(month, 10) > 12) return "";
    if (numbers?.length >= 4 && parseInt(day, 10) > 31) return "";

    if (numbers?.length >= 5) {
      return `${month}/${day}/${year}`;
    } else if (numbers?.length >= 3) {
      return `${month}/${day}`;
    } else if (numbers?.length >= 1) {
      return `${month}`;
    }

    return "";
  };

  const validateDate = (date, documentId) => {
    if (!date) {
      setDateErrors((prev) => ({ ...prev, [documentId]: "Date is required" }));
      return false;
    }

    if (date < minDate) {
      setDateErrors((prev) => ({
        ...prev,
        [documentId]: "Date cannot be before 1900",
      }));
      return false;
    }

    if (date > maxDate) {
      setDateErrors((prev) => ({
        ...prev,
        [documentId]: "Date cannot be in the future",
      }));
      return false;
    }

    setDateErrors((prev) => ({ ...prev, [documentId]: "" }));
    return true;
  };

  const handleDateChange = (date, documentId) => {
    if (validateDate(date, documentId)) {
      setDocumentDates((prev) => {
        const existing = prev.find((item) => item.documentId === documentId);
        if (existing) {
          return prev.map((item) =>
            item.documentId === documentId ? { ...item, date } : item
          );
        }
        return [...prev, { documentId, date }];
      });
    }
  };

  const handleSubmit = () => {
    const todayInUSA = new Date().toLocaleString("en-US", {
      timeZone: "America/New_York",
    });

    const today = new Date(todayInUSA);

    const formattedDates = documents.map((doc) => {
      const selectedDate =
        documentDates.find((item) => item.documentId === doc.id)?.date || today;

      const d = new Date(selectedDate);
      const formattedDate = `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;

      return {
        id: doc.id,
        version_date: formattedDate,
      };
    });

    onSubmit(formattedDates);
  };

  const handleClose = () => {
    handleSubmit();
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Select Document Dates
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mt-3 text-muted px-4">
          <small>
            <i>
              Note: You can select a date for each document. If no date is
              selected, today's date will be considered.{" "}
              <span className="text-danger">
                Do not refresh or close the page.
              </span>
            </i>
          </small>
        </div>
        <div className="document-dates">
          {documents.map((doc) => (
            <div
              key={doc.id}
              className="document-date-item d-flex justify-content-between align-items-center mb-3"
            >
              <span className="document-name">{doc.name}</span>
              <div style={{ width: "330px" }}>
                <DatePicker
                  selected={
                    documentDates.find((item) => item.documentId === doc.id)
                      ?.date
                  }
                  onChange={(date) => handleDateChange(date, doc.id)}
                  className={`form-control custom-datepicker ${
                    dateErrors[doc.id] ? "is-invalid" : ""
                  }`}
                  dateFormat="MM/dd/yyyy"
                  placeholderText="MM/DD/YYYY"
                  // showYearDropdown
                  // yearDropdownItemNumber={5}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  minDate={minDate}
                  maxDate={maxDate}
                  onKeyDown={(e) => {
                    // Allow only numbers, backspace, tab, and arrow keys
                    if (
                      !/\d/.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key !== "Tab" &&
                      !e.key.includes("Arrow")
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onChangeRaw={(e) => {
                    const formattedValue = formatDateInput(e.target.value);
                    e.target.value = formattedValue;

                    // Try parsing the date
                    const numbers = formattedValue
                      .replace(/\D/g, "")
                      .substring(0, 8);
                    if (numbers.length === 8) {
                      const mm = parseInt(numbers.substring(0, 2), 10);
                      const dd = parseInt(numbers.substring(2, 4), 10);
                      const yyyy = parseInt(numbers.substring(4), 10);

                      const parsedDate = new Date(yyyy, mm - 1, dd);

                      // Check if valid date
                      if (
                        parsedDate &&
                        parsedDate.getMonth() === mm - 1 &&
                        parsedDate.getDate() === dd &&
                        parsedDate.getFullYear() === yyyy
                      ) {
                        handleDateChange(parsedDate, doc.id);
                      }
                    }
                  }}
                />
                {dateErrors[doc.id] && (
                  <div className="invalid-feedback d-block">
                    {dateErrors[doc.id]}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="bttn-close" onClick={handleClose}>
          Close
        </button>
        <button
          className="bttn-upload"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default UploadDocuments;
